'use client';
import { loginSuccess, logoutSuccess } from '@/components/default/redux/slices/authSlice';
import { RootState } from '@/components/default/redux/store';
import DashboardService from '@/components/default/services/api/dashboard/dashboard.service';
import CookieService from '@/components/default/services/app/cookie.service';
// import StorageService from '@/components/default/services/app/storage.service';
// import { showToastrErrorAlert } from '@/components/default/utils/common';
// import Loading from '@/components/layouts/loading';
import React from 'react';
// , { useState }
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import StorageService from '../services/app/storage.service';
import Loading from '@/components/layouts/loading';
// import Swal from 'sweetalert2';
const AuthProvider = ({
    children,
}: Readonly<{
    children: React.ReactNode;
}>) => {
    const dispatch = useDispatch();
    const [load, setLoad] = React.useState(false);
    const { domainType, mainDomain, subDomain, customDomain } = useSelector((state: RootState) => state.domain);
    React.useEffect(() => {
        const validateUser = async () => {
            const cookieToken = CookieService.get('token');
            if (cookieToken) {
                // ✅ Do your login validation here...
                DashboardService.checkLoggedInTenant()
                    .then((response) => {
                        // console.log('Dashboard response:', response);
                        dispatch(
                            loginSuccess({
                                user: (({
                                    id,
                                    name,
                                    designation,
                                    country,
                                    address,
                                    phone,
                                    email,
                                    image,
                                    registration,
                                    sub_domain,
                                    custom_domain,
                                    type,
                                    youtube,
                                    facebook,
                                    twitter,
                                    linkedin,
                                    status,
                                }) => ({
                                    id,
                                    name,
                                    designation,
                                    country,
                                    address,
                                    phone,
                                    email,
                                    image,
                                    registration,
                                    sub_domain,
                                    custom_domain,
                                    type,
                                    youtube,
                                    facebook,
                                    twitter,
                                    linkedin,
                                    status,
                                }))(response.data.user),
                                token: response.data.access_token,
                                role: response.data.user.role,
                                permissions: response.data.user.permissions,
                            }),
                        );
                    })
                    .catch((error) => {
                        // console.log('error', error);
                        dispatch(logoutSuccess());
                        CookieService.clear();
                        StorageService.clear();
                    }).finally(() => {
                        setLoad(true);
                    });
                return;
            }else {
                setLoad(true)
            }
        };
        if (domainType) {
            validateUser();
        }
    }, [domainType, customDomain, mainDomain, subDomain, dispatch]);

    if (!load) return <Loading />;

    return <>{children}</>;
};
export default AuthProvider;
